import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './RGPD.css';

interface RGPDProps {
  privacyPolicyUrl?: string;
}

const RGPD: React.FC<RGPDProps> = ({ 
  privacyPolicyUrl = '/legal' 
}) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState<boolean>(false);
  
  useEffect(() => {
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    if (!cookiesAccepted) {
      setVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setVisible(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookiesDeclined', 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="rgpd-container">
      <div className="rgpd-content">
        <p>
          {t('rgpd.cookieMessage')}{' '}
          <a href={privacyPolicyUrl} className="rgpd-link">
            {t('rgpd.privacyPolicy')}
          </a>.
        </p>
        <div className="rgpd-buttons">
          <button 
            onClick={declineCookies} 
            className="rgpd-decline"
          >
            {t('rgpd.decline')}
          </button>
          <button 
            onClick={acceptCookies} 
            className="rgpd-accept"
          >
            {t('rgpd.accept')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RGPD;
